angular.module('ihestiaMenuSearchBox',
  ['ihestia-menu-templates-app', 'ihestiaCommonDirectives']
);